module.exports = __webpack_public_path__ + "img/2.8dd01d5a.jpg";